import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";

/**
 * Slim inline strip that appears on inner pages (product/case detail) to remind
 * visitors that Maxine's core practice is ERP. Realistic tone — no direct SAP
 * name-check, just clear positioning.
 */
export default function ErpBadge({ compact = false }) {
  return (
    <Link
      to="/#erp"
      data-testid="erp-badge"
      className={`inline-flex items-center gap-2 border border-[color:var(--brand)] bg-[color:var(--brand)]/5 hover:bg-[color:var(--brand)]/10 transition-colors ${
        compact ? "px-3 py-1.5" : "px-4 py-2"
      }`}
    >
      <ShieldCheck size={14} weight="bold" className="text-[color:var(--brand)]" />
      <span className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--brand)]">
        Part of Maxine ERP · 12 industry suites
      </span>
      <ArrowRight size={12} weight="bold" className="text-[color:var(--brand)]" />
    </Link>
  );
}
